<template>
    <marquee class="announcement-msg" v-if="config?.announcement?.value">
        {{ config?.announcement?.value }}
    </marquee>
    <router-view v-if="init" :key="$route.fullPath"></router-view>
</template>

<script>
import { computed } from 'vue';
import { getWalletAuth } from '../services/module';
import marquee from '@/shared/services/marqueeService';

export default {
    name: "WalletModule",
    components: {
        marquee
    },
    data() {
        return {
            init: false,
            config: null,
            walletData: null
        }
    },
    provide() {
        return { 
            walletConfig : computed(() => this.config),
            // onlyBank: computed(() => !!this.config?.agents.find(agent => agent == this.$auth.user.cpi) || false),
        }
    },
    created() {
        if(!this.$auth?.user?.isDemo){
            this.getWalletAuth();
        }else{
            this.$errorToast('Wallet access is restricted for demo users')
            this.$router.push({name:'Home'})
        }
    },
    methods: {
        async getWalletAuth(){
            try {
                let response = await getWalletAuth();
                if(response?.data){
                    this.config = response.data
                    this.init = true
                }
            } catch (error) {
                this.$errorToast(error)
            }
        }
    }
}
</script>